import "./SingleCard.css";

export default function SingleCard({ flipped, c , choice, disabled}) {

    const handleClick = () => {
        if (!disabled) {
            choice(c) // this function is back in app.js
        }
    }

  return (
    <div className="card"> 
      <div className={flipped ? "flipped" : ""}>
        <img className="front" src={c.src} alt="inside" />
        <img
          className="back"
          src="/img/uw.png"
          onClick={handleClick}
          alt="cover"
        />
      </div>
    </div>
  );
}
